import Icon from 'veui/components/Icon'

Icon.register({
  'image-add': {
    paths: [
      {
        d: 'M27.34 4.5c.28 0 .5.22.5.5a.5.5 0 01-.5.5H4.04A2.52 2.52 0 001.51 8v22c0 1.38 1.14 2.5 2.53 2.5H32.4c1.4 0 2.53-1.12 2.53-2.5V13a.5.5 0 011.01 0v17c0 1.93-1.58 3.5-3.54 3.5H4.04A3.52 3.52 0 01.5 30V8c0-1.93 1.59-3.5 3.54-3.5zM21.2 17.05a2.55 2.55 0 014.15 0l5.43 7.66a.5.5 0 01-.13.7.51.51 0 01-.7-.12l-5.43-7.66a1.53 1.53 0 00-2.49 0l-5.43 7.66a.5.5 0 01-.12.12l.07-.06a.5.5 0 01-.05.04l-.02.02a.52.52 0 01-.46.06.51.51 0 01-.25-.18l.06.07a.5.5 0 01-.04-.04l-.02-.03-3.41-4.72a1.53 1.53 0 00-2.47 0l-3.42 4.72a.51.51 0 01-.7.12.5.5 0 01-.12-.7l3.41-4.72a2.55 2.55 0 014.12 0l3 4.14zM10.12 11.5c1.4 0 2.53 1.12 2.53 2.5s-1.13 2.5-2.53 2.5A2.52 2.52 0 017.59 14c0-1.38 1.13-2.5 2.53-2.5zm0 1c-.84 0-1.52.67-1.52 1.5s.68 1.5 1.52 1.5 1.52-.67 1.52-1.5-.68-1.5-1.52-1.5zM35.44.5c.28 0 .5.22.5.5v4H40a.5.5 0 110 1h-4.06v4a.5.5 0 01-.5.5h-.01a.5.5 0 01-.5-.5V6h-4.06a.5.5 0 110-1h4.06V1c0-.28.22-.5.5-.5h.01z',
        fill: 'currentColor'
      }
    ],
    width: '41',
    height: '34'
  }
})
